import {
  AnalysisType,
  LinkedRecordingItemType,
  LongeingDirection,
} from '../types';

export interface LinkedRecording {
  id: string;
  type: AnalysisType;
  longeingDirection: LongeingDirection;
}

export interface ILinkedRecordings {
  sources: ILinkedRecordingItem[];
  targets: ILinkedRecordingItem[];
}

export class LinkedRecordings implements ILinkedRecordings {
  sources: ILinkedRecordingItem[];
  targets: ILinkedRecordingItem[];

  constructor(o: any = {}) {
    this.sources = o['sources']
      ? o['sources'].map((item: any) => new LinkedRecordingItem(item))
      : [];
    this.targets = o['targets']
      ? o['targets'].map((item: any) => new LinkedRecordingItem(item))
      : [];
  }
}

export interface ILinkedRecordingItem {
  id: string;
  type: LinkedRecordingItemType;
}

export class LinkedRecordingItem implements ILinkedRecordingItem {
  id: string;
  type: LinkedRecordingItemType;

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.type = o['type'] ?? null;
  }
}
